import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Box, Typography } from "@mui/material";
import { useRef } from "react";
import { useWindowWidth } from "./Vibes/useWindow";
import { truncateText } from "../utils/truncateText";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { IconButton } from "@mui/material";

const SliderComponent = ({
  itemsWithSup,
  handleItems,
  baseUrl,
  errorLayoutGlobal,
}) => {
  const windowWidth = useWindowWidth();

  const swiperRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const isMobile = windowWidth < 600;
  const isSmall = windowWidth >= 600 && windowWidth < 900;
  const isLarge = windowWidth >= 900;

  const showButtons =
    (isMobile && itemsWithSup?.length >= 4) ||
    (isSmall && itemsWithSup?.length >= 6) ||
    (isLarge && itemsWithSup?.length >= 8);

  return (
    <Box
      position="relative"
      sx={{
        minHeight: "158px",
        maxHeight: "158px",
        pb: 1,
      }}
      className={`${!showButtons ? "center" : ""}`}
    >
      {itemsWithSup?.length === 0 ? (
        <Typography
          sx={{
            textAlign: "center",
            color: "rgba(60, 60, 67, 0.45)",
            fontSize: "13px",
            pt: 4,
          }}
        >
          No items available
        </Typography>
      ) : (
        <Swiper
          modules={[Navigation, Mousewheel]}
          spaceBetween={4}
          loop={true}
          mousewheel={{
            enabled: showButtons ? true : false,
          }}
          centeredSlides={showButtons ? true : false}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          breakpoints={{
            1: {
              slidesPerView: Math.min(itemsWithSup?.length || 1, 3),
            },
            600: {
              slidesPerView: 5,
            },
            900: {
              slidesPerView: 7,
            },
          }}
        >
          {itemsWithSup?.map((item, index) => {
            return (
              <SwiperSlide key={index}>
                <Box
                  sx={{
                    padding: "6px 2px",
                    overflow: "visible",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    handleItems(item._id, item, "add", errorLayoutGlobal)
                  }
                >
                  <Box
                    sx={{
                      backgroundColor: "rgba(255, 255, 255, 0.7)",
                      borderRadius: "22px",
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                      minHeight: "140px",
                      maxHeight: "140px",
                      pt: 0.5,
                      px: 0.5,
                      pb: 0.5,
                      border: "1px solid rgba(218, 218, 218, 0.5)",
                      position: "relative",
                    }}
                  >
                    <img
                      src={`${baseUrl}/g${item?.frontViewImage}`}
                      alt={item?.name}
                      style={{
                        width: "96px",
                        height: "96px",
                        objectFit: "contain",
                        flexShrink: 0,
                      }}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        pl: 0.25,
                        pr: 0.5,
                        gap: 0.25,
                        flex: 1,
                        minHeight: 0,
                        mt: "2px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "10px",
                          fontWeight: 500,
                          color: "rgba(32, 33, 36, 0.8)",
                          lineHeight: 1.2,
                          textAlign: "left",
                          flex: 1,
                          maxWidth: "calc(100% - 4px)",
                          pl: "4px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {truncateText(item.name, 20)}
                      </Typography>

                      <IconButton
                        size="small"
                        sx={{
                          width: 20,
                          height: 20,
                          flexShrink: 0,
                          backgroundColor: "rgba(32, 33, 36, 0.06)",
                          color: "rgba(32, 33, 36, 0.6)",
                          "&:hover": {
                            backgroundColor: "rgba(32, 33, 36, 0.12)",
                          },
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleItems(item._id, item, "add", errorLayoutGlobal);
                        }}
                      >
                        <AddOutlinedIcon sx={{ fontSize: 13 }} />
                      </IconButton>
                    </Box>
                  </Box>
                </Box>
              </SwiperSlide>
            );
          })}

          {showButtons && (
            <>
              <IconButton
                ref={prevRef}
                onClick={() => swiperRef.current?.slidePrev()}
                size="small"
                sx={{
                  position: "absolute",
                  left: 2,
                  top: "45%",
                  transform: "translateY(-50%)",
                  zIndex: 1,
                  width: 24,
                  height: 24,
                  backgroundColor: "rgba(255, 255, 255, 0.92)",
                  border: "1px solid rgba(218, 218, 218, 0.4)",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                  },
                }}
              >
                <ArrowBackIosNewIcon sx={{ fontSize: 11, color: "rgba(32, 33, 36, 0.5)" }} />
              </IconButton>

              <IconButton
                ref={nextRef}
                onClick={() => swiperRef.current?.slideNext()}
                size="small"
                sx={{
                  position: "absolute",
                  right: 2,
                  top: "45%",
                  transform: "translateY(-50%)",
                  zIndex: 1,
                  width: 24,
                  height: 24,
                  backgroundColor: "rgba(255, 255, 255, 0.92)",
                  border: "1px solid rgba(218, 218, 218, 0.4)",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                  },
                }}
              >
                <ArrowForwardIosIcon sx={{ fontSize: 11, color: "rgba(32, 33, 36, 0.5)" }} />
              </IconButton>
            </>
          )}
        </Swiper>
      )}
    </Box>
  );
};

export default SliderComponent;
